import gql from 'graphql-tag';

export const START_MODULE_MUTATION = gql`
  mutation trackUserFlowStep($userFlowStepId: Int!) {
    userFlowStepTrack {
      startUserFlowStep(stepId: $userFlowStepId) {
        id
      }
    }
  }
`;
